export enum EventGroupType {
    nonTracked = "",
    api = "api",
    appointments = "appointments",
    userInteraction = "userInteraction",
    solutions = "solutions",
    ticketCreation = "ticketCreation",
    panelLogic = "panelLogic",
    fullPage = "fullPage",
    quickStarts = "quickstarts"
}
  